import { render, staticRenderFns } from "./StatBoxes.vue?vue&type=template&id=b3c2360a&scoped=true&"
import script from "./StatBoxes.vue?vue&type=script&lang=js&"
export * from "./StatBoxes.vue?vue&type=script&lang=js&"
import style0 from "./StatBoxes.vue?vue&type=style&index=0&id=b3c2360a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c2360a",
  null
  
)

export default component.exports